import React, { useState } from "react";

import {
	FrontendCompanyWithAdditionalInfomation,
	FrontendTempFilePasswordManagement,
} from "node-library/dist/portal";
import { useTranslation } from "react-i18next";

import { formatCustomDate } from "node-library/dist/helpers/date_helper";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Card, IconButton } from "@mui/material";
import { ButtonTextLoadingAnimation } from "../../../common-components/animation/ButtonLoadingAnimation";
import {
	BlackButton,
	CustomIconButton,
	GreenButton,
} from "../../../common-components/button";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	filePassword: FrontendTempFilePasswordManagement;
	goBackToViewFilePage: (refresh: boolean) => void;

	setAddEditModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
	adminInAction: boolean;
	setDeleteConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	deleteFile: (fileId: string) => void;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function FilePasswordDetailsContent(props: Props) {
	const { t: translation } = useTranslation();
	const [showPassword, setShowPassword] = useState<boolean>(true);

	const {
		company,
		filePassword,
		goBackToViewFilePage,
		setAddEditModalOpen,
		adminInAction,
		setDeleteConfirmOpen,
		deleteFile,
		setProceedAction,
	} = props;

	let actionOptions: Array<{
		children: React.ReactNode;
	}> = [
		{
			children: (
				<GreenButton
					key={`edit-file-password-info`}
					id={"edit-file-password-info"}
					onClick={() => {
						setAddEditModalOpen(true);
					}}
					disabled={adminInAction}
				>
					{adminInAction ? (
						<ButtonTextLoadingAnimation
							text={translation("Loading")}
						></ButtonTextLoadingAnimation>
					) : (
						translation("Edit")
					)}
				</GreenButton>
			),
		},
		{
			children: (
				<BlackButton
					key={`delete-file-password-info`}
					id={"delete-file-password-info"}
					onClick={() => {
						setProceedAction(() => () => deleteFile(filePassword.id));

						setDeleteConfirmOpen(true);
					}}
					disabled={adminInAction}
				>
					{adminInAction ? (
						<ButtonTextLoadingAnimation
							text={translation("Loading")}
						></ButtonTextLoadingAnimation>
					) : (
						translation("Delete")
					)}
				</BlackButton>
			),
		},
	];

	const actionRow: React.ReactNode = (
		<div
			style={{ display: "flex", flexWrap: "wrap", gap: "10px", float: "right" }}
		>
			{actionOptions.map((option) => {
				return option.children;
			})}
		</div>
	);
	const fileBody: React.ReactNode = (
		<div
			style={{
				marginTop: "10px",
				display: "flex",
				flexDirection: "column",
				gap: "5px",
			}}
		>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">{translation("Name")}</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{filePassword.name}
				</div>
			</div>
			<div
				className="order-cell-body-row typography-body-02"
				style={{ alignItems: "center" }}
			>
				<div className="sample-info-row-description">
					{translation("Password")}
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "5px",
						maxWidth: "50%",
					}}
				>
					<div className="overflow-ellipsis-text">
						{showPassword ? filePassword.password : "••••••••"}
					</div>

					<IconButton
						size="small"
						onClick={(e) => {
							setShowPassword((prev) => !prev);
						}}
					>
						{showPassword ? <VisibilityOff /> : <Visibility />}
					</IconButton>
				</div>
			</div>

			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Createdon")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{formatCustomDate(filePassword.inserted as Date)}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Lastupdatedon")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{formatCustomDate(filePassword.lastUpdated as Date)}
				</div>
			</div>
		</div>
	);
	return (
		<div>
			<CustomIconButton
				id="register-back-button"
				onClick={() => goBackToViewFilePage(false)}
				icon={<KeyboardArrowLeftIcon />}
			></CustomIconButton>
			{actionRow}
			<Card
				className="common-card card-border-radius-14p card-medium-padding"
				key={filePassword.id}
			>
				{fileBody}
			</Card>
		</div>
	);
}
